export const Triangle = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="8"
			height="8"
			viewBox="0 0 8 8"
			fill="none"
		>
			<path
				d="M7.69336 8V0C7.69336 0 0.000736237 2.76923 0.000736237 3.89744C0.000736237 5.02564 7.69336 8 7.69336 8Z"
				fill="#7A3F1E"
			/>
			<path
				d="M8 7.40661V0.591797C8 0.591797 0.922787 2.95077 0.922787 3.91184C0.922787 4.8729 8 7.40661 8 7.40661Z"
				fill="#FFFAF1"
			/>
		</svg>
	);
};
